import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsDividerBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsDividerBlockEntity
